export default __webpack_public_path__ + "static/media/logo-white.9dc43776.png";